import {
  INIT, SUCCESS, LOADING, ERROR,
} from '../../../utils/constants';
import {
  GET_AZURE_SITES, GET_AZURE_SITES_SUCCESS, GET_AZURE_SITES_ERROR
} from './constant';


const initialState = {
  phase: INIT,
  azureSiteList: null,
  error: null,
};

/**
 * User Reducer
 * @param {Object} state
 * @param {Object} action
 */
 

export function AzureSiteStore(state = initialState, action) {
  switch (action.type) {
    case GET_AZURE_SITES:
      return {
        ...state,
        phase: LOADING,
      };
    case GET_AZURE_SITES_SUCCESS:
      return {
        ...state,
        phase: SUCCESS,
        azureSubList: action.data,
        error: null,
      };
    case GET_AZURE_SITES_ERROR:
      return { ...state, phase: ERROR, error: action.error };





    default:
      return state;
  }
}
